import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import { NotFound } from '@/components/Message/NotFound';

type ResultImmatVINProps = {
  className?: string;
  immat: string;
  vin: string;
};

export const ResultImmatVIN = ({
  className,
  immat,
  vin,
}: ResultImmatVINProps) => {
  const { t } = useTranslation('inspection');
  return (
    <div className={twMerge('card', className)}>
      <div className="card-body max-sm:p-2">
        <div className="flex flex-wrap justify-center gap-2 py-1 max-sm:gap-4">
          <div
            className={twMerge(
              'flex flex-col justify-center items-center gap-1.5 max-sm:gap-1',
              immat && 'max-sm:gap-0.5',
            )}
          >
            {immat && (
              <span
                className={twMerge(
                  'text-gray-900 text-2xl lg:text-2.5xl font-semibold break-all text-center leading-tight max-sm:text-2xl',
                  immat && 'max-sm:order-2',
                )}
              >
                {immat}
              </span>
            )}
            <span
              className={twMerge(
                'text-slate-500 text-sm max-sm:font-semibold',
                immat && 'max-sm:order-1',
              )}
            >
              {t('common:licensePlateNumber')}
            </span>
            {!immat && (
              <NotFound
                text={t('notMentionedDuringInspection')}
                containerClassName="gap-1"
                iconClassName="text-lg text-purple-A713F6"
                textClassName="text-sm font-semibold text-purple-A713F6"
              />
            )}
          </div>
          <span className="sm:ml-8 sm:pl-8 border-l border-l-gray-200"></span>
          <div className="flex flex-col justify-center items-center gap-1.5 max-sm:gap-0">
            {vin && (
              <span
                className={twMerge(
                  'text-gray-900 text-2xl lg:text-2.5xl font-semibold break-all text-center leading-tight max-sm:text-2xl',
                  vin && 'max-sm:order-2',
                )}
              >
                {vin}
              </span>
            )}
            <span
              className={twMerge(
                'text-slate-500 text-sm max-sm:font-semibold',
                vin && 'max-sm:order-1',
              )}
            >
              {t('common:vin')}
            </span>
            {!vin && (
              <NotFound
                text={t('notMentionedDuringInspection')}
                containerClassName="gap-1"
                iconClassName="text-lg text-purple-A713F6"
                textClassName="text-sm font-semibold text-purple-A713F6"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
